import { IS_PROD } from '../config/'

import fetch from 'isomorphic-fetch'

const MAILCHIMP_REGISTER_NEWSLETTER_ENDPOINT =
  'https://console.snips.ai/api/register-email-to-list'

export function postEmailToMailchimp (email, listId, status) {
  const postBody = {
    email,
    listId,
    status,
    source: window.location.href
  }

  if (!IS_PROD) {
    console.info('DEV::post email to mailchimp', postBody)
    return Promise.resolve()
  }

  return fetch(MAILCHIMP_REGISTER_NEWSLETTER_ENDPOINT, {
    body: JSON.stringify(postBody),
    method: 'POST',
    mode: 'cors',
    headers: {
      'content-type': 'application/json'
    }
  })
}

export function postEmailToMailchimpAndSheets (email, collectionConfig = {}) {
  // 1. Post to Atomic for sending emails via Mailchimp
  if (collectionConfig.mailchimpListId) {
    postEmailToMailchimp(
      email,
      collectionConfig.mailchimpListId,
      collectionConfig.mailchimpStatus
    )
  }

  // 2. Post to GA Spreadsheet
  // NOTE: posting to a Google Form like this is not the supported way,
  // and does raise a CORS warning in the browser (although the POST comes through)
  // TODO: Find a supported way to POST to Google Spreadsheet.
  const googleSpreadsheetsConfig = collectionConfig.googleSpreedsheet
  if (!googleSpreadsheetsConfig) {
    return
  }
  if (IS_PROD) {
    const spreadsheetHttp = new window.XMLHttpRequest()
    spreadsheetHttp.open('POST', googleSpreadsheetsConfig.url, true)
    // Send the proper header information along with the request
    spreadsheetHttp.setRequestHeader(
      'Content-type',
      'application/x-www-form-urlencoded'
    )

    // NOTE: hardcoded to only handle email id - should loop through and use all ids
    spreadsheetHttp.send(
      googleSpreadsheetsConfig.ids.email + '=' + encodeURIComponent(email)
    )
  } else {
    console.info(
      'DEV::post email to google spreadsheet',
      googleSpreadsheetsConfig.url
    )
  }
}



// WEBPACK FOOTER //
// ./frontend/scripts/utils/email.js